const CONFIRMED_LABEL = "Confirmed";
export default CONFIRMED_LABEL;
